import { render, staticRenderFns } from "./ConfigurationDefaultEntityForMobileApp.vue?vue&type=template&id=12a5e56a&scoped=true&"
import script from "./ConfigurationDefaultEntityForMobileApp.vue?vue&type=script&lang=js&"
export * from "./ConfigurationDefaultEntityForMobileApp.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationDefaultEntityForMobileApp.vue?vue&type=style&index=0&id=12a5e56a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a5e56a",
  null
  
)

export default component.exports